import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteEventStage($companyId: ID!, $id: ID!) {
    deleteEventStage(companyId: $companyId, id: $id) {
      eventStage {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
